var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"1px solid gray","border-radius":"5px"}},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"height":"300px","options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }